<template>
<div>
  <v-row class="betask-bg p-3" no-gutters>
      <v-col cols="3">
        <v-avatar size="54px">
          <img v-if="profile.pictureUrl" alt="Avatar" :src="profile.pictureUrl">
        </v-avatar>
      </v-col>
      <v-col cols="9" class="Raleway font16 pt-4 bold">
        {{profile.displayName}}
      </v-col>
    </v-row>
     <v-overlay :value="overlay">
     <v-progress-circular
        indeterminate
        size="64"
        color="#F3E9DD"
      ></v-progress-circular>
    </v-overlay>
    <v-container>
      <h5 class="py-3">บัตรสะสมแต้มของคุณ</h5>
      <v-row v-if="!dataItem">
        <v-col>
          <v-alert
            dense
            outlined
            type="error"
          >
            ไม่มี <strong>ข้อมูลร้านค้า</strong>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="dataItem">
        <v-col md="6" xs="12" sm="12" lg="6" v-for="(item, index) in dataItem" :key="index">
          <v-card
            class="mx-auto rounded-lg"
            elevation="2"
          >
            <v-list-item three-line>
              <v-list-item-avatar
                size="80"
                color="grey"
              >
                <v-img
                alt="user"
                :src="item.shopLogo"
              />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h6 mt-0 pt-0 mb-1 RalewayBold">
                  {{item.shopName}}<br>
                </v-list-item-title>
                สะสม {{formatNumber(item.currentPoint)}} คะแนน
              </v-list-item-content>

            </v-list-item>

            <v-card-actions>
              <v-btn
                color="primary"
                class="rounded-lg"
                block
                @click="selectShop(item.shopId)"
              >
                ไปที่ร้านนี้
                <v-icon
                  right
                  dark
                  class="pl-1"
                >
                  mdi-store
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MemberShop',
  data () {
    return {
      dataItem: [],
      session: this.$session.getAll(),
      profile: [],
      member: null,
      overlay: true
    }
  },
  async mounted () {
    // this.$session.remove('shopId')
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()

    await this.getData()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapActions('shopStore', ['setShopId', 'getShopTheme']),
    ...mapActions('memberStore', ['getMemberProfile']),

    async getData () {
      this.dataItem = []
      const result = await this.callBeTaskAPI('get', '/member/getListShop')
      if (typeof result.status !== 'undefined') {
        this.dataItem = []
      } else {
        this.dataItem = result
      }
      this.overlay = false
    },
    async selectShop (shopId) {
      await this.setShopId(shopId)
      await this.getMemberProfile()
      // this.$session.start()
      // await this.$session.set('shopId', shopId)
      // this.$session.remove('shopId')
      // this.$session.start()
      // this.$session.set('shopId', shopId)
      await this.getShopTheme()
      await this.getTheme()
      await this.getShop()
      // await this.$session.remove('shopPrompt')
      this.redirectToPage(shopId)
    },
    async redirectToPage (shopId) {
      let redirectUrl = (this.$route.query.redirectUrl) ? decodeURI(this.$route.query.redirectUrl) : `/home?shopId=${shopId}`
      window.location.href = (redirectUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register/MemberShop.vue